import type { JSX } from 'react';

import { Separator } from '@change-corgi/design-system-legacy/components/content';
import { Box, Container } from '@change-corgi/design-system-legacy/layout';
import { derivedStyle } from '@change-corgi/design-system-legacy/theme';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

export function InfoSection(): JSX.Element {
	return (
		<Container px={[8, 16]}>
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: ['1fr', '1fr 1fr 1fr'],
					gap: 16,
				}}
				pt={40}
				pb={32}
			>
				{['35+ Organizations', '$5+ Million', '17+ States and DC'].map((text) => (
					<Box
						key={text}
						sx={{
							position: 'relative',
							textAlign: 'center',
							'&:not(:last-child):after': {
								content: '""',
								display: ['none', 'block'],
								position: 'absolute',
								height: 20,
								right: -(16 / 2),
								top: '50%',
								mt: -(20 / 2),
								borderRight: derivedStyle(({ colors }) => `1px solid ${colors['neutral-grey400']}`),
							},
						}}
					>
						<Text size="large">{text}</Text>
					</Box>
				))}
			</Box>
			<Separator sx={{ display: ['block', 'none'] }} mb={40} />
			<Box pb={32}>
				<Heading as="h2" size="h3">
					Racial justice petitions are the largest in Change.org’s history.
				</Heading>
				<Box py={16}>
					<Text as="div">
						Last year’s racial justice reckoning prompted two students to start petitions demanding justice for George
						Floyd and Breonna Taylor. More than 30 million signers around the world joined their call, making them the
						largest petitions our site has ever seen. Since then, Change.org has pledged millions from those petitions
						to support Black-led organizations and movements that empower racial justice work.
					</Text>
					<br />
					<Text as="div">
						Through a process, under the guidance of North Star Fund, a New York-based community foundation, more than
						35 Black-led organizations were selected across the United States. Each grant will support their work on the
						frontlines disrupting anti-Blackness and empowering communities of color.
					</Text>
					<br />
					<Text as="div">
						Black-led organizations are statistically overwhelmingly excluded from philanthropic support. The Racial
						Justice Fund is part of Change.org’s commitment to equitable philanthropic practices and systemic change.
						The work has only just begun.
					</Text>
				</Box>
			</Box>
		</Container>
	);
}
